(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.consts = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.ErrorMessage = void 0;
  // Error Msgs
  var ErrorMessage = _exports.ErrorMessage = {
    invalid_api_key: 'Invalid API Key',
    subscription_inactive: 'SUBSCRIPTION_INACTIVE'
  };
});